export default {
  text: 'Vous gagnez <highlight>{{value}} points</highlight> avec cette commande',
};
